import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5128f68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }

import i18, { State as I18State } from '@/store/i18';
import Layout from '@/views/layouts/desktop/Root.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import Menus from './Menus.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].gospel)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, { "left-width": 220 }, {
    "left-side": _withCtx(() => [
      _createVNode(Menus)
    ]),
    "top-bar": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(lang).title), 1)
    ]),
    _: 1
  }))
}
}

})